import { Button, Heading, Text, HStack, VStack, Icon } from '@genial/components';
import { useNavigation } from '@react-navigation/native';
import React from 'react';

import { SignedInNavigationScreenNavigationProp } from '../../../../routes/types';
import { fixedFeeDescription, fixedFeeTitle } from '../../constants';

import { FixedFeeHeaderProps } from '.';

export const FixedFeeHeaderDesktop: React.FC<FixedFeeHeaderProps> = ({ hasSomeImpersonation }) => {
  const { navigate } = useNavigation<SignedInNavigationScreenNavigationProp>();

  return (
    <HStack justifyContent="space-between" alignItems="center" flexWrap="wrap" space="stack.xxxs">
      <VStack space="stack.nano" flex={1} minW={0}>
        <Heading testId="fixed-fee-title" size="h2">
          {fixedFeeTitle}
        </Heading>
        <Text fontSize="lg" color="neutral.dark" variant="light">
          {fixedFeeDescription}
        </Text>
      </VStack>

      <Button
        isDisabled={hasSomeImpersonation}
        onPress={() => navigate('FixedFeeNewContractModal')}
        rightIcon={<Icon name="PlusBigger" size="xxs" color="neutral.white" />}>
        Nova contratação
      </Button>
    </HStack>
  );
};
